import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from './message.service';
import { ProcessRecall } from '../models/ProcessRecall';
import { QCReport } from '../models/qcReport';

@Injectable({ providedIn: 'root' })

export class ReportService {
  private _ENDPOINT = '';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,
    private messageService: MessageService, @Inject('BASE_URL') baseUrl) {
    this._ENDPOINT = baseUrl + 'api/reports';
  }
  
  getMailingErrorReport(id: number): Observable<Array<QCReport>> {
    return this.http.get<Array<QCReport>>(this._ENDPOINT + '/?id=' + id);
  }
    
  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a MailingService message with the MessageService */
  private log(message: string) {
    this.messageService.add('MailingService: ${message}');
  }
}
